import { Form, Select } from 'antd';
import React from 'react';

import type { SelectorFieldProps } from '../../types';

const SelectorField = ({
  label,
  name,
  rules,
  mode,
  placeholder,
  options,
}: SelectorFieldProps) => {
  return (
    <Form.Item label={label} name={name} rules={rules}>
      <Select
        showArrow
        allowClear
        mode={mode}
        placeholder={placeholder}
        options={options}
      />
    </Form.Item>
  );
};

export default SelectorField;
